export const validEmail = /.+@.+\.[a-zA-Z]+/g;
